import type { ContextType } from "react";
import { AppContext } from "../../../store";

export const ADD_ON_PURCHASE_TYPE = "add_on_purchase";
export const FIRST_PURCHASE = "FIRST_PURCHASE";
export const REPURCHASE = "REPURCHASE";
export const SAFETY_PRICE = "SAFETY_PRICE";
export const CONTACT_US = "ContactUs";
export const PREVIEW = "Preview";

export type LoginState = ContextType<typeof AppContext>["loginState"];
export interface AddOnPurchaseProduct {
  sku: string;
  category?: string;
  subCategory?: string;
  activityId?: number;
  productName: string;
  productSize?: string;
  productPic?: string;
  description?: string;
  pdpViewable?: boolean;
  available: boolean;
  listPrice?: string | null;
  finalPrice?: string | null;
  priceStatus?: string | null;
  purchaseType: typeof FIRST_PURCHASE | typeof REPURCHASE | typeof SAFETY_PRICE;
  limitQty?: number | null;
  shoppingQty?: number;
}
export interface AddOnPurchaseCardProps {
  product: AddOnPurchaseProduct;
  activityId?: string | number;
  loginState: LoginState;
  previewFlag?: boolean;
  onAddToCart?: () => void;
}
export interface AddOnPurchaseListProps extends Omit<AddOnPurchaseCardProps, "product"> {
  products: AddOnPurchaseProduct[];
}
export interface AddOnPurchaseListRequest {
  activityId: string | number;
  type: string;
  categories: string[];
  queryKey?: string;
  pageNum: number;
  pageSize: number;
  shipTo?: string;
}
export interface AddOnPurchasePage {
  data: AddOnPurchaseProduct[];
  total: number;
  pageNum: number;
  pageTotal: number;
}
